// Parser label-based untuk memisahkan teks bebas menjadi Ucapan / Dari / Alamat.
// Aturan: keyword di awal baris (case-insensitive, dengan/tanpa ":"), multiline,
// mempertahankan line break, mengabaikan metadata order (harga, tanggal, dll)
// yang berada sebelum label pertama atau berlabel meta.

const SECTION_RE = /^\s*(ucapan|dari|alamat)\b\s*[:\-–.]?\s*/i;
const META_RE = /^\s*(harga|dasar|modal|tanggal|tgl|order|invoice|inv|no\.?|nomor|total|subtotal|qty|jumlah|pembayaran|metode|kas|bank)\b\s*[:\-]/i;

export function parseKartuUcapan(text) {
  const result = { ucapan: "", dari: "", alamat: "" };
  if (!text) return result;
  const lines = text.split("\n");
  const hasSection = lines.some((l) => SECTION_RE.test(l));
  // Teks tanpa label apapun -> semua dianggap ucapan (kompatibel data lama)
  if (!hasSection) {
    result.ucapan = text.trim();
    return result;
  }
  let current = null;
  for (const rawLine of lines) {
    const line = rawLine.replace(/\s+$/, "");
    if (!line.trim()) {
      // pertahankan baris kosong tunggal di dalam section
      if (current && result[current] && !result[current].endsWith("\n")) result[current] += "\n";
      continue;
    }
    const m = line.match(SECTION_RE);
    if (m) {
      current = m[1].toLowerCase();
      const rest = line.slice(m[0].length).trim();
      if (rest) result[current] += (result[current] ? "\n" : "") + rest;
      continue;
    }
    if (current === null) continue; // metadata sebelum label pertama
    if (META_RE.test(line)) continue; // baris meta di dalam teks
    result[current] += (result[current] ? "\n" : "") + line.trimStart();
  }
  for (const k of Object.keys(result)) result[k] = result[k].replace(/\n{2,}/g, "\n").trim();
  return result;
}
